module.exports = __webpack_public_path__ + "static/media/Relative-Bold-Web.87910e43.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Bold-Web.eot
// module id = 743
// module chunks = 0